import React from "react";
import {
  X,
  CheckCircle2,
  Users,
  Building2,
  UserCheck,
  AlertTriangle,
  MapPin,
  Briefcase,
} from "lucide-react";
import "../styles/UploadResults.css";

const UploadResultsModal = ({ results, onClose }) => {
  if (!results) return null;

  const { summary } = results;

  return (
    <div className="upload-results-overlay">
      <div className="upload-results-modal">
        {/* Header */}
        <div className="results-header">
          <div className="results-title">
            <CheckCircle2 size={32} className="success-icon" />
            <div>
              <h2>העלאה הושלמה בהצלחה!</h2>
              <p>{results.rows_imported?.toLocaleString()} שורות יובאו</p>
            </div>
          </div>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        {/* Stats Grid */}
        <div className="results-stats">
          <div className="stat-card sites">
            <div className="stat-icon">
              <Building2 size={28} />
            </div>
            <div className="stat-info">
              <span className="stat-value">{summary?.sites_count || 0}</span>
              <span className="stat-label">אתרים</span>
            </div>
          </div>

          <div className="stat-card employees">
            <div className="stat-icon">
              <Users size={28} />
            </div>
            <div className="stat-info">
              <span className="stat-value">{summary?.employees_count || 0}</span>
              <span className="stat-label">עובדים</span>
            </div>
          </div>

          <div className="stat-card new-employees">
            <div className="stat-icon">
              <UserCheck size={28} />
            </div>
            <div className="stat-info">
              <span className="stat-value">{results.new_employees_count || 0}</span>
              <span className="stat-label">עובדים חדשים</span>
            </div>
          </div>
        </div>

        {/* Employee Types */}
        {summary?.employee_types && (
          <div className="section employee-types-section">
            <h3>
              <Briefcase size={20} />
              סוגי עובדים
            </h3>
            <div className="types-grid">
              <div className="type-card kablan">
                <span className="type-value">
                  {summary.employee_types["קבלן"] || 0}
                </span>
                <span className="type-label">קבלן</span>
              </div>
              <div className="type-card company">
                <span className="type-value">
                  {summary.employee_types["חברה"] || 0}
                </span>
                <span className="type-label">חברה</span>
              </div>
              <div className="type-card both">
                <span className="type-value">
                  {summary.employee_types["קבלן ו חברה"] || 0}
                </span>
                <span className="type-label">קבלן ו חברה</span>
              </div>
            </div>
          </div>
        )}

        {/* Multi-site Employees */}
        {summary?.multi_site_employees?.length > 0 && (
          <div className="section multi-site-section">
            <h3>
              <AlertTriangle size={20} className="warning-icon" />
              עובדים בריבוי אתרים ({summary.multi_site_count})
            </h3>
            <p className="section-desc">
              העובדים הבאים עבדו ביותר מאתר אחד בתקופה זו
            </p>
            <div className="multi-site-list">
              {summary.multi_site_employees.map((emp, idx) => (
                <div
                  key={emp.employee_id}
                  className="multi-site-employee"
                  style={{ animationDelay: `${idx * 0.1}s` }}
                >
                  <span className="emp-name">{emp.employee_name}</span>
                  <div className="emp-sites">
                    {emp.sites.map((site, sIdx) => (
                      <span key={sIdx} className="site-badge">
                        <MapPin size={12} />
                        {site}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="results-footer">
          <button className="btn-close" onClick={onClose}>
            סגור
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadResultsModal;
